import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import HomePage from './Pages/HomePage';
import 'bootstrap/dist/css/bootstrap.min.css';
import AskAnExpert from './Pages/AskAnExpert';
import JoblistingPage from './Pages/JoblistingPage';
import CVReview from './Pages/CVReview';
import LatestNews from './Pages/LatestNews';
import OurMission from './Pages/OurMission';
import { useEffect } from 'react';
import { useAuth } from './Context/ContextProvider';
import ContactUs from './Pages/ContactUs';
import ScholarshipPage from './Pages/ScholarshipPage';
import NewsDetail from './Pages/NewsDetail';
import JobDetailPage from './Pages/JobDetailPage';
import ScollershipDetail from './Pages/ScollershipDetail';
import MediaRoomPage from './Pages/MediaRoomPage';
import MediaDetailPage from './Pages/MediaDetailPage';
import QuickNewsPage from './Pages/QuickNewsPage';
import ScrolToTop from './Pages/ScrolToTop';

function App() {
    const {getCities,citiesList, setCitieslist, getCategories, setCategorieslist, getQuickNews, setQuickNews}=useAuth()

      console.log(citiesList);
      useEffect(()=>{
          const fetchData=async ()=>{
            try {
          // Fetch Cities
          const citiesResult = await getCities();
          setCitieslist(citiesResult?.data);
  
              
        } catch (error) {
          console.error("An error occurred while fetching data:", error);
        }
          }
          const fetchCategories=async ()=>{
            try {
              const categoriesResult = await getCategories();
              setCategorieslist(categoriesResult?.data?.categories);
            } catch (error) {
              console.error("An error occurred while fetching categories:", error);
            }
          }
          fetchData()
          fetchCategories()
      },[])
      useEffect(() => {
        const fetchQuickNews = async () => {
          const result = await getQuickNews()
          if (result?.success) {
            setQuickNews(result?.data?.quickNews)
          }
        }
        fetchQuickNews()
      }, [])
  return (
<BrowserRouter>
<ScrolToTop/>
<Routes>
  <Route path='/' element={<HomePage/>} />
  <Route path='/ask-an-expert/:slug' element={<AskAnExpert/>} />
  <Route path='/find-new-job' element={<JoblistingPage/>} />
  <Route path='/find-new-scholarship' element={<ScholarshipPage/>} />
  <Route path='/cv-review' element={<CVReview/>}/>
  <Route path='/latest-news' element={<LatestNews/>}/>
  <Route path='/our-mission' element={<OurMission/>}/>
  <Route path='/contact-us' element={<ContactUs/>}/>
  <Route path='/news-detail/:id' element={<NewsDetail/>}/>
  <Route path='/job-detail/:id' element={<JobDetailPage/>}/>
  <Route path='/scholarship-detail/:id' element={<ScollershipDetail/>}/>
  <Route path='/media-room' element={<MediaRoomPage/>}/>
  <Route path='/media-detail/:id' element={<MediaDetailPage/>}/>
  <Route path='/quick-news' element={<QuickNewsPage/>}/>
</Routes>
</BrowserRouter>
  );
}

export default App;
